<template>
  <v-expansion-panel outlined class="mb-4">
    <v-expansion-panel-title>Como escribir un acta dialogica</v-expansion-panel-title>
    <v-expansion-panel-text>
      <v-list dense>
        <v-list-item>
          <v-chip color="blue lighten-2" dark small class="mr-2">Compromiso</v-chip>
          <span> -> "Compromiso:"</span>
        </v-list-item>
        <v-list-item>
          <v-chip color="orange lighten-2" dark small class="mr-2">Duda</v-chip>
          <span> -> "Duda:"</span>
        </v-list-item>
        <v-list-item>
          <v-chip color="green lighten-2" dark small class="mr-2">Acuerdo</v-chip>
          <span> -> "Acuerdo:"</span>
        </v-list-item>
        <v-list-item>
          <v-chip color="grey" dark small class="mr-2">Texto libre</v-chip>
          <span> -> No es necesario prefijo</span>
        </v-list-item>
        <v-divider class="my-2"></v-divider>
        <v-list-item>
          <v-chip color="primary" dark small class="mr-2">@Responsable</v-chip>
          <span> -> @PrimerNombre del correo "@usach"</span>
        </v-list-item>
        <v-list-item>
          <v-chip color="primary" dark small class="mr-2">Fecha</v-chip>
          <span> -> En formato dd-mm-aaaa</span>
        </v-list-item>
        <v-list-item>
          <v-chip color="primary" dark small class="mr-2">Hora</v-chip>
          <span> -> En formato 24 horas de la forma hh:mm</span>
        </v-list-item>
      </v-list>
    </v-expansion-panel-text>
  </v-expansion-panel>
</template>

<script>
export default{
  name: 'WritingActa',
}
</script>